import { PrismicNextLink } from "@prismicio/next";
import { isFilled } from "@prismicio/client";

/**
 * @typedef {import("@prismicio/client").Content.LegalInfoSlice} LegalInfoSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<LegalInfoSlice>} LegalInfoProps
 * @type {import("react").FC<LegalInfoProps>}
 */
const LegalInfo = ({ slice }) => {
  return (
    <div
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="w-full flex flex-col md:flex-row-reverse justify-between items-center gap-1"
    >
      <div className="flex gap-4">
        {Array.isArray(slice.primary.link) && slice.primary.link.map((linkItem, index) => (
          isFilled.link(linkItem) && (
            <PrismicNextLink
              key={index}
              field={linkItem}
              className="text-legal"
            />
          )
        ))}
      </div>
      <div className="text-copyright">
        © Site web réalisé avec des pixels par <a href="https://www.aztk.io" target="_blank" rel="noopener noreferrer">AZTK</a>
      </div>
    </div>
  );
};

export default LegalInfo;
